class Slider {
  constructor(containerSelector, slideSelector) {
    this.currentIndex = 0;
    this.slides = document.querySelectorAll(slideSelector);
    this.totalSlides = this.slides.length - 1; // 减去复制的最后一张图片
    this.sliderContainer = document.querySelector(containerSelector);
    this.intervalId = null;
    this.isDragging = false;
    this.startX = 0;
    this.currentX = 0;
    this.initialOffset = 0;
    this.sliderTrack = this.sliderContainer.querySelector(".slider-track"); // 缓存 DOM 查询结果
    this.isMoved = false; // 新增标志位，用于判断是否发生了移动

    // 为每个 slide 生成唯一的 id
    this.slides.forEach((slide, index) => {
      slide.id = `slide-${index + 1}`;
    });

    this.init();
  }

  init() {
    this.showSlide(this.currentIndex);
    this.startAutoSlide();
    this.addEventListeners();
    // 初始化懒加载
    this.lazyLoadImages();
  }

  showSlide(index) {
    if (index < 0) {
      this.currentIndex = this.totalSlides - 1;
    } else if (index >= this.slides.length) {
      this.currentIndex = 0;
    } else {
      this.currentIndex = index;
    }
    const offset = -this.currentIndex * 100;
    requestAnimationFrame(() => {
      this.sliderTrack.style.transform = `translateX(${offset}%)`; // 使用缓存的 DOM 查询结果
    });
  }

  nextSlide() {
    this.stopAutoSlide();
    this.showSlide(this.currentIndex + 1);
    this.startAutoSlide();
  }

  prevSlide() {
    this.stopAutoSlide();
    this.showSlide(this.currentIndex - 1);
    this.startAutoSlide();
  }

  startAutoSlide() {
    this.intervalId = setInterval(() => this.nextSlide(), 5000);
  }

  stopAutoSlide() {
    clearInterval(this.intervalId);
  }

  handleSwipe(startX, endX) {
    if (startX - endX > 200) {
      this.nextSlide();
    } else if (endX - startX > 200) {
      this.prevSlide();
    }
  }

  updateTransform(diffX) {
    const scaleFactor = 0.1; // 鼠标移动 10px 时，图片移动 1px
    const scaledDiffX = diffX * scaleFactor;
    const newOffset = this.initialOffset + scaledDiffX;
    // 使用 CSS 过渡来平滑过渡
    this.sliderTrack.style.transition = "transform 0.1s ease-in-out"; // 使用缓存的 DOM 查询结果
    this.sliderTrack.style.transform = `translateX(${newOffset}%)`; // 使用缓存的 DOM 查询结果
  }

  handleTouchStart(event) {
    this.isDragging = true;
    this.startX = event.touches[0].clientX;
    this.currentX = this.startX;
    this.initialOffset = -this.currentIndex * 100;
    this.sliderTrack.style.transition = "none"; // 使用缓存的 DOM 查询结果
    event.preventDefault(); // 阻止默认的拖拽行为

    // 记录初始位置
    this.dragStartX = event.touches[0].clientX;
  }

  handleTouchMove(event) {
    if (this.isDragging) {
      const moveX = event.touches[0].clientX;
      const diffX = moveX - this.dragStartX;

      if (Math.abs(diffX) > 20) {
        // 检查是否滑动超过20px
        this.isMoved = true; // 设置移动标志位
      }

      if (this.isMoved) {
        requestAnimationFrame(() => {
          this.updateTransform(diffX);
        });
        this.currentX = moveX;

        // 设置href为空
        const links = this.sliderContainer.querySelectorAll("a");
        links.forEach((link) => {
          link.href = "";
        });
      }
    }
  }

  handleTouchEnd(event) {
    if (this.isDragging) {
      this.isDragging = false;
      const endX = this.currentX;
      const diffX = endX - this.startX;

      const threshold = 200; // 鼠标移动 200px 时切换图片

      if (diffX > threshold) {
        this.prevSlide();
      } else if (diffX < -threshold) {
        this.nextSlide();
      } else {
        this.showSlide(this.currentIndex);
      }

      this.sliderTrack.style.transition = "transform 0.5s ease-in-out"; // 使用缓存的 DOM 查询结果

      // 恢复链接的 href 属性
      const links = this.sliderContainer.querySelectorAll("a");
      links.forEach((link) => {
        if (!link.dataset.originalHref) {
          link.dataset.originalHref = link.href; // 保存原始 href
        }
        link.href = link.dataset.originalHref; // 恢复 href
      });

      // 如果没有移动，则允许跳转
      if (!this.isMoved) {
        const targetLink = event.target.closest("a");
        if (targetLink && targetLink.href) {
          window.location.href = targetLink.href;
        }
      }
    }
  }

  addEventListeners() {
    // 添加触摸事件监听器
    this.sliderContainer.addEventListener("touchstart", (event) =>
      this.handleTouchStart(event)
    );
    this.sliderContainer.addEventListener("touchmove", (event) =>
      this.handleTouchMove(event)
    );
    this.sliderContainer.addEventListener("touchend", (event) =>
      this.handleTouchEnd(event)
    );
  }

  lazyLoadImages() {
    const images = this.sliderContainer.querySelectorAll("img[data-src]");
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.src;
            img.removeAttribute("data-src");
            observer.unobserve(img);
          }
        });
      },
      {
        threshold: 0.1,
      }
    );

    images.forEach((img) => {
      observer.observe(img);
    });
  }
}

// 使用示例
window.addEventListener("load", () => {
  window.slider = new Slider(".slider-container", ".slider-slide");
});
document.querySelectorAll(".link-next").forEach((link) => {
  let isDragging = false;
  let startX, startY;

  link.addEventListener("mousedown", (e) => {
    isDragging = false;
    startX = e.clientX;
    startY = e.clientY;
  });

  link.addEventListener("mousemove", (e) => {
    if (Math.abs(e.clientX - startX) > 5 || Math.abs(e.clientY - startY) > 5) {
      isDragging = true;
    }
  });

  link.addEventListener("click", (e) => {
    if (isDragging) {
      e.preventDefault();
    }
    isDragging = false;
  });
});

// -----------------倒计时--------------

// class Countdown {
//   constructor(endTime) {
//     this.endTime = endTime;
//     this.intervalId = null;
//     this.updateCountdown();
//     this.startCountdown();
//   }

//   startCountdown() {
//     this.intervalId = setInterval(() => {
//       this.updateCountdown();
//     }, 1000);
//   }

//   updateCountdown() {
//     const now = getUSACurrentTime().getTime();
//     const distance = this.endTime - now;

//     const days = Math.floor(distance / (1000 * 60 * 60 * 24));
//     const hours = Math.floor(
//       (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
//     );
//     const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//     const seconds = Math.floor((distance % (1000 * 60)) / 1000);

//     document.getElementById("days").innerText = days;
//     document.getElementById("hours").innerText = hours;
//     document.getElementById("minutes").innerText = minutes;
//     document.getElementById("seconds").innerText = seconds;

//     if (distance < 0) {
//       clearInterval(this.intervalId);
//       document.getElementById("days").innerText = "0";
//       document.getElementById("hours").innerText = "0";
//       document.getElementById("minutes").innerText = "0";
//       document.getElementById("seconds").innerText = "0";
//     }
//   }
// }

// // 获取当前的美国时间
// function getUSACurrentTime() {
//   const options = { timeZone: "America/New_York", timeZoneName: "short" };
//   return new Date(new Date().toLocaleString("en-US", options));
// }

// // 初始化倒计时结束时间
// let countdownDate;

// // 检查 localStorage 中是否有倒计时结束时间
// if (localStorage.getItem("countdownEndTime")) {
//   countdownDate = new Date(parseInt(localStorage.getItem("countdownEndTime")));
// } else {
//   const initialTime = getUSACurrentTime().getTime();
//   const countdownDuration = 80 * 24 * 60 * 60 * 1000; // 80天的毫秒数
//   countdownDate = new Date(initialTime + countdownDuration);
//   localStorage.setItem("countdownEndTime", countdownDate.getTime());
// }

// const countdown = new Countdown(countdownDate);

// ------------------------------tags
function openTab(tabName) {
  // 获取所有选项卡内容元素
  var tabContents = document.getElementsByClassName("tab-content");
  for (var i = 0; i < tabContents.length; i++) {
    tabContents[i].style.display = "none";
  }
  // 获取所有选项卡按钮元素
  var tabButtons = document
    .getElementsByClassName("tab-buttons")[0]
    .getElementsByTagName("button");
  for (var i = 0; i < tabButtons.length; i++) {
    tabButtons[i].classList.remove("active");
  }
  // 显示当前选项卡内容
  document.getElementById(tabName).style.display = "block";
  // 为当前选项卡按钮添加 active 类
  // 这里因为是鼠标悬停事件，不能用 event.currentTarget，直接通过传参找对应的按钮
  for (var i = 0; i < tabButtons.length; i++) {
    if (tabButtons[i].onmouseover.toString().includes(tabName)) {
      tabButtons[i].classList.add("active");
      break;
    }
  }
}

// 折叠内容的 JavaScript 代码
var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  // 将 click 事件改为 mouseover 事件
  acc[i].addEventListener("mouseover", function () {
    this.classList.add("active");
    var panel = this.nextElementSibling;
    panel.style.display = "block";
  });
  // 新增鼠标移出事件，鼠标移出时折叠内容收起
  acc[i].addEventListener("mouseout", function () {
    this.classList.remove("active");
    var panel = this.nextElementSibling;
    panel.style.display = "none";
  });
}

// -----------------------滑动轮播
class Carousel {
  constructor(selector) {
    this.containers = document.querySelectorAll(selector);
    this.initEventListeners();
  }

  initEventListeners() {
    this.containers.forEach((container) => {
      let isDragging = false;
      let startX;
      let startScrollLeft;

      // 鼠标事件
      container.addEventListener("mousedown", (e) => {
        e.preventDefault();
        isDragging = true;
        startX = e.pageX - container.offsetLeft;
        startScrollLeft = container.scrollLeft;
        container.style.cursor = "grabbing";
      });

      container.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        const x = e.pageX - container.offsetLeft;
        container.scrollLeft = startScrollLeft - (x - startX);
      });

      // 触摸事件
      container.addEventListener("touchstart", (e) => {
        e.preventDefault();
        const touch = e.touches[0];
        startX = touch.pageX - container.offsetLeft;
        startScrollLeft = container.scrollLeft;
      });

      container.addEventListener("touchmove", (e) => {
        if (!e.touches[0]) return;
        const touch = e.touches[0];
        const x = touch.pageX - container.offsetLeft;
        container.scrollLeft = startScrollLeft - (x - startX);
      });

      // 通用清理事件
      const cleanup = () => {
        isDragging = false;
        startX = null;
        startScrollLeft = null;
        container.style.cursor = "grab";
      };

      ["mouseup", "mouseleave", "touchend", "touchcancel"].forEach((event) => {
        container.addEventListener(event, cleanup);
      });
    });
  }
}

// 初始化示例
new Carousel(".slide-waper");
